import React, { useState, useRef, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import { useCookies } from 'react-cookie'
import moment from 'moment'
import { Parser as HtmlToReactParser } from 'html-to-react'

import Dialog from '../../../1stlog-ui/src/components/Dialog'
import useAgb from './useAgb'

export { default as useAgb } from './useAgb'

const COOKIE_NAME = 'agbRead'

const Agb = (props) => {
  const [cookies, setCookie] = useCookies([COOKIE_NAME])

  const { isOpen, open, close, isAvailable } = useAgb()

  const agbRead = lodash.get(cookies, COOKIE_NAME)

  const newsIsNewer =
    !agbRead || moment(agbRead).isBefore(moment(lodash.get(global.agb, 'updated_at')))

  useEffect(() => {
    if (newsIsNewer) {
      open()
    }
  }, [])

  const closeDialog = () => {
    setCookie(COOKIE_NAME, moment(lodash.get(global.agb, 'updated_at')).toISOString(), {
      path: '/',
      expires: new Date(Date.now() + 12096e5),
    })
    close()
  }

  const html = useMemo(() => getHtml(), [])

  const isActuallyOpen = !(!isOpen && (!html || (!newsIsNewer && !props.isForced)))

  if (!isAvailable) {
    return null
  }

  return (
    <Dialog
      isOpen={isActuallyOpen}
      title={i18n.t('agb_long', 'Allgemeine Geschäftsbedingungen')}
      lg
      backdrop="static"
      onSubmit={closeDialog}
      submitButton={i18n.t('agb_accept', 'Akzeptieren')}
    >
      {html}
    </Dialog>
  )
}

export default Agb

function getHtml() {
  try {
    const rawHtml = lodash.get(global.agb, 'content_html')
    var htmlToReactParser = new HtmlToReactParser()
    var reactElement = htmlToReactParser.parse(rawHtml)
    return reactElement
  } catch (err) {
    return null
  }
}
